import { Component } from '@angular/core';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./shared.css']
})
export class ForgotPasswordComponent {
  email = '';
  message = '';
  error = '';
  resetLink = '';

  constructor(private auth: AuthService) {}

  send(): void {
    this.error = '';
    this.message = '';
    this.resetLink = '';

    this.auth.forgotPassword(this.email).subscribe({
      next: (res: any) => {
        this.message = res?.message || 'Reset link sent.';
        this.resetLink = res?.reset_link || '';
      },
      error: (err) => this.error = err?.error?.error || 'Failed to send reset link'
    });
  }
}